import { Link } from "react-router-dom";
import { Instagram, Twitter, Facebook, MapPin, Phone, Mail } from "lucide-react";
import { trackEvent } from "../lib/analytics";

export default function Footer() {
  return (
    <footer className="border-t border-[#222] bg-black mt-24" data-testid="site-footer">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <div className="font-display text-3xl tracking-tight">TORONTO CUSTOM</div>
          <p className="text-zinc-400 mt-3 max-w-sm font-body text-sm">
            Premium custom apparel printing in Toronto & the GTA. Design online, ship anywhere in Canada or pick up in Mississauga.
          </p>
          <ul className="mt-4 space-y-2 text-zinc-400 text-xs font-mono">
            <li className="flex items-center gap-2"><MapPin size={12} className="text-[var(--tc-red)] flex-shrink-0" /> 2404 HAINES RD SUITE 209, MISSISSAUGA, ON</li>
            <li className="flex items-center gap-2"><Phone size={12} className="text-[var(--tc-red)] flex-shrink-0" /> <a href="tel:+12892053623" data-testid="footer-phone-link" onClick={() => trackEvent("phone_click", { source: "footer" })} className="hover:text-white">(289) 205-3623</a></li>
            <li className="flex items-center gap-2"><Mail size={12} className="text-[var(--tc-red)] flex-shrink-0" /> <a href="mailto:torontocustomt@gmail.com" data-testid="footer-email-link" onClick={() => trackEvent("email_click", { source: "footer" })} className="hover:text-white normal-case lowercase">torontocustomt@gmail.com</a></li>
          </ul>
          <div className="flex gap-3 mt-6">
            <a href="#" aria-label="Instagram" data-testid="social-instagram" className="p-3 border border-[#222] hover:border-[var(--tc-red)]"><Instagram size={16} /></a>
            <a href="#" aria-label="X / Twitter" data-testid="social-twitter" className="p-3 border border-[#222] hover:border-[var(--tc-red)]"><Twitter size={16} /></a>
            <a href="#" aria-label="Facebook" data-testid="social-facebook" className="p-3 border border-[#222] hover:border-[var(--tc-red)]"><Facebook size={16} /></a>
          </div>
        </div>
        <div>
          <div className="font-mono text-[11px] tracking-widest text-zinc-500 mb-4">CUSTOMIZE</div>
          <ul className="space-y-2 text-zinc-300 font-body text-sm">
            <li><Link to="/customize">T-Shirts</Link></li>
            <li><Link to="/customize">Hoodies</Link></li>
            <li><Link to="/customize">Polos & Hats</Link></li>
            <li><Link to="/bulk-orders">Bulk / Team</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-mono text-[11px] tracking-widest text-zinc-500 mb-4">SHOP</div>
          <ul className="space-y-2 text-zinc-300 font-body text-sm">
            <li><Link to="/ready-made">Ready-Made</Link></li>
            <li><Link to="/ready-made/anime">Anime</Link></li>
            <li><Link to="/ready-made/horror">Horror</Link></li>
            <li><Link to="/ready-made/videogames">Gaming</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-mono text-[11px] tracking-widest text-zinc-500 mb-4">SUPPORT</div>
          <ul className="space-y-2 text-zinc-300 font-body text-sm">
            <li><Link to="/faq">FAQ</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/shipping">Shipping</Link></li>
            <li><Link to="/refunds">Refunds</Link></li>
            <li><Link to="/privacy">Privacy</Link></li>
            <li><Link to="/terms">Terms</Link></li>
          </ul>
        </div>
      </div>

      {/* Service-area internal linking block — huge SEO boost (sitewide footer links to every city x service combo) */}
      <div className="border-t border-[#222] bg-[#070707]">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-10">
          <div className="font-mono text-[11px] tracking-widest text-zinc-500 mb-4">SERVING THE GTA · <Link to="/service-areas" className="text-zinc-300 hover:text-white">SEE ALL</Link></div>
          <div className="flex flex-wrap gap-x-4 gap-y-2 text-zinc-400 font-mono text-[10px] tracking-widest uppercase">
            {[
              ["custom-tshirts-toronto", "Custom T-Shirts Toronto"],
              ["custom-tshirts-mississauga", "T-Shirts Mississauga"],
              ["custom-tshirts-brampton", "T-Shirts Brampton"],
              ["custom-hoodies-toronto", "Hoodies Toronto"],
              ["custom-hoodies-mississauga", "Hoodies Mississauga"],
              ["dtf-printing-toronto", "DTF Toronto"],
              ["dtf-printing-mississauga", "DTF Mississauga"],
              ["vinyl-printing-toronto", "Vinyl Toronto"],
              ["bulk-printing-toronto", "Bulk Toronto"],
              ["bulk-printing-mississauga", "Bulk Mississauga"],
              ["custom-tshirts-vaughan", "T-Shirts Vaughan"],
              ["custom-tshirts-markham", "T-Shirts Markham"],
              ["custom-tshirts-scarborough", "T-Shirts Scarborough"],
              ["custom-tshirts-etobicoke", "T-Shirts Etobicoke"],
              ["custom-tshirts-oakville", "T-Shirts Oakville"],
              ["custom-tshirts-north-york", "T-Shirts North York"],
            ].map(([slug, label]) => (
              <Link key={slug} to={`/${slug}`} className="hover:text-white">{label}</Link>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-[#222] py-6">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-10 flex flex-col md:flex-row justify-between items-center gap-3">
          <div className="font-mono text-[11px] tracking-widest text-zinc-500">
            © {new Date().getFullYear()} TORONTO CUSTOM T-SHIRTS. ALL RIGHTS RESERVED.
          </div>
          <div className="font-mono text-[11px] tracking-widest text-zinc-500">
            CRAFTED IN THE 6IX · SQUARE SECURE CHECKOUT
          </div>
        </div>
      </div>
    </footer>
  );
}
